import React, { PropTypes } from 'react';
import { TextField, FontIcon, RadioButton, RaisedButton } from 'material-ui';
import ContractingYear from '../../template-list/create-template-draft/components/contracting-year';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
const SaveAsTemplate = (props, { router }) => {
  const {
    templateName,
    onFieldChange,
    saveAsANewTemplate,
    saving,
    onRequestClose,
    duplicateTemplateName,
    newDraftStartDate,
    newDraftEndDate,
    saveAsNewTemplateFinished,
    newDraft,
    sourceTemplatePeriod,
    shouldClearDates,
    forBuyer,
    makeACopySuccessPayload = {},
    push,
  } = props;
  const differentYear = newDraftStartDate && newDraftEndDate
    && sourceTemplatePeriod.startDate && sourceTemplatePeriod.endDate
    && new Date(newDraftStartDate).toISOString() !== new Date(sourceTemplatePeriod.startDate).toISOString()
    && new Date(newDraftEndDate).toISOString() !== new Date(sourceTemplatePeriod.endDate).toISOString();
  const sameMonthDay = newDraftStartDate && newDraftEndDate
    && sourceTemplatePeriod.startDate && sourceTemplatePeriod.endDate
    && new Date(newDraftStartDate).getUTCMonth() === new Date(sourceTemplatePeriod.startDate).getUTCMonth()
    && new Date(newDraftStartDate).getUTCDate() === new Date(sourceTemplatePeriod.startDate).getUTCDate()
    && new Date(newDraftEndDate).getUTCMonth() === new Date(sourceTemplatePeriod.endDate).getUTCMonth()
    && new Date(newDraftEndDate).getUTCDate() === new Date(sourceTemplatePeriod.endDate).getUTCDate();

  return (
    <div style={{ padding: '0 12px 12px 12px' }}>
      {
        (() => {
          if (forBuyer) {
            if (makeACopySuccessPayload.wsId) {
              return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <ul style={{ width: '80%', margin: 'auto', fontSize: '12px', textAlign: 'left' }}>
                    <li>A new rate sheet is generated with the content of this rate sheet and dates justified accordingly.</li>
                    <li>New rate sheet will be in a new workspace based on the date selected.</li>
                    <li>You can send the rate sheet to supplier to complete the rate sheet and/or sign the rate sheet whenever you are ready.</li>
                  </ul>
                  <RaisedButton
                    label="Go to Workspace"
                    secondary
                    onClick={() => {
                      push(`/contracting/contract/${makeACopySuccessPayload.wsId}/policies`);
                      onRequestClose('');
                    }}
                  />
                </div>
              );
            }
            return (
              <div style={{ padding: '20px' }}>
                <ContractingYear
                  required
                  startDate={newDraftStartDate}
                  endDate={newDraftEndDate}
                  onChange={(key, value) => onFieldChange({ key: `newDraft${key === 'startDate' ? 'StartDate' : 'EndDate'}`, value })}
                />
              </div>
            );
          }
          if (saveAsNewTemplateFinished) {
            return (
              <div style={{ margin: '20px', textAlign: 'center' }}>
                A new template has been created.
                <FlatButton
                  secondary
                  label="Go To The New Template."
                  onClick={() => {
                    onRequestClose('');
                    router.push(`/contracting/draft/${newDraft.originalContractId}/details`
                    );
                  }}
                />
              </div>
            );
          }
          return (
            <div style={{ margin: '20px' }}>
              <label><b>Please enter a name for the new template:</b></label> <span style={{ color: 'red' }}>* Required</span>
              <br/>
              <TextField
                style={{ width: '400px' }}
                floatingLabelText="Name the new template"
                defaultValue={templateName}
                errorText={duplicateTemplateName ? `There is already a template named "${templateName}" for this contracting period.` : ''}
                onChange={({ target: { value } }) => onFieldChange({ key: 'templateName', value })}
              />
              <br/>

              <ContractingYear
                required
                startDate={newDraftStartDate}
                endDate={newDraftEndDate}
                onChange={(key, value) => onFieldChange({ key: `newDraft${key === 'startDate' ? 'StartDate' : 'EndDate'}`, value })}
              />
              {
                (() => {
                  // different year
                  if (differentYear) {
                    // same month day
                    if (sameMonthDay) {
                      return (
                        <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginTop: '12px', height: '64px' }}>
                          <FontIcon className="tc-icon-warning2" color="grey" />
                          <div style={{ display: 'inline-block', marginLeft: '8px' }}>
                            The dates in your new template will be updated for the selected year. Please review your dates carefully before finalising your template.
                          </div>
                        </div>
                      );
                    }
                    return (
                      <div>
                        <label><b>Would you like to keep the dates from this template?</b></label><span style={{ color: 'red' }}>* Required</span>
                        <br/>
                        <RadioButton
                          label="Yes, I will review and modify the dates accordingly"
                          checked={shouldClearDates === false}
                          onCheck={() => onFieldChange({ key: 'shouldClearDates', value: false })}
                        />
                        <RadioButton
                          label="No, please clear the dates"
                          checked={shouldClearDates}
                          onCheck={() => onFieldChange({ key: 'shouldClearDates', value: true })}
                        />
                      </div>
                    );
                  }
                })()
              }
              <br/>
              <small style={{ paddingLeft: '38px' }}><i>Note: A separate template will be created.</i></small>
            </div>
          );
        })()
      }
      <StepperActions
        rightButtons={
          <div>
            <FlatButton
              label="Dismiss"
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              primary
              onClick={onRequestClose}
            />
            <FlatButton
              label="Confirm"
              loader={saving}
              disabled={forBuyer
                ? Boolean(!newDraftEndDate || !newDraftStartDate || makeACopySuccessPayload.wsId)
                : Boolean(!templateName
                  || !newDraftEndDate
                  || !newDraftStartDate
                  || saveAsNewTemplateFinished
                  || (differentYear && !sameMonthDay && typeof shouldClearDates !== 'boolean'))
              }
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              secondary
              onClick={saveAsANewTemplate}
            />
          </div>
        }
      />
    </div>
  );
};

SaveAsTemplate.propTypes = {
  templateName: PropTypes.string,
  saveAsTemplateBool: PropTypes.bool,
  onFieldChange: PropTypes.func,
  saveAsANewTemplate: PropTypes.func,
  saving: PropTypes.bool,
  onRequestClose: PropTypes.func,
  checkingContractReadiness: PropTypes.bool,
  errors: PropTypes.object,
  locationId: PropTypes.string,
  duplicateTemplateName: PropTypes.bool,
  newDraftStartDate: PropTypes.string,
  newDraftEndDate: PropTypes.string,
  saveAsNewTemplateFinished: PropTypes.bool,
  newDraft: PropTypes.object,
  sourceTemplatePeriod: PropTypes.object,
  shouldClearDates: PropTypes.bool,
};

SaveAsTemplate.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default SaveAsTemplate;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/publish-draft-content/save-as-template.jsx